export var DataTestLabel;
(function (DataTestLabel) {
    DataTestLabel["NavigationPrevious"] = "asset-viewer-navigation-previous";
    DataTestLabel["NavigationNext"] = "asset-viewer-navigation-next";
})(DataTestLabel || (DataTestLabel = {}));
//# sourceMappingURL=data-test-label.type.js.map